export const FETCHING_MORE = 'cardlists/FETCHING_MORE'
export const FETCHING_MORE_ERROR = 'cardlists/FETCHING_MORE_ERROR'
export const FETCHING_MORE_SUCCESS = 'cardlists/FETCHING_MORE_SUCCESS'
export const SET_STATE = 'cardlists/SET_STATE'
export const SET_ADDITIONAL_FILTERS = 'cardlists/SET_ADDITIONAL_FILTERS'
export const SUBMIT_FILTERS = 'cardlists/SUBMIT_FILTERS'
export const TOGGLE_PERSIST = 'cardlists/TOGGLE_PERSIST'
